import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromErrors from '../fromErrors.barrel';

const state = createFeatureSelector<fromErrors.State>(fromErrors.errorsFeatureKey);

export const selectHttpErrors = createSelector(state, state => state.httpErrors);
export const selectGeneralErrors = createSelector(state, state => state.generalErrors);
export const selectGlobalErrors = createSelector(selectHttpErrors, selectGeneralErrors, (http, general) => [...http, ...general]);

export const selectHttpErrorMessages = createSelector(selectHttpErrors, http => http.map(e => ({ name: 'HTTP Error', message: e.error.message })));
export const selectGeneralErrorMessages = createSelector(selectGeneralErrors, gen => gen.map(e => ({ name: 'General Error', message: e.message })));

export const selectErrorMessages = createSelector(state, state => [...state.generalErrors, ...state.httpErrors]);
